import React from 'react';
import {
  ThreadListLabel,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListSubHeader/components/ThreadListLabel';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDStack } from '@facet-wealth/design';
import {
  MessagesComposeButton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListSubHeader/components/MessagesComposeButton';
import {
  BulkCommunicationButton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListSubHeader/components/BulkCommunicationButton';

const ThreadListSubHeader = () => {
  const { pageContentResource: messagesPageResource } = usePageContentContext();

  return (
    <FDStack flexGrow={1} justifyContent={'space-between'} alignItems={'center'}>
      <ThreadListLabel />
      <FDStack justifyContent={'flex-end'}>
        {hasRelationship(messagesPageResource, fr.relationships.bulkCommunication.name)
          ? <BulkCommunicationButton /> : null}
        {messagesPageResource?.withRelationship(fr.relationships.composeNewMessage.name, () => <MessagesComposeButton />, () => null)}
      </FDStack>
    </FDStack>
  );
};

ThreadListSubHeader.defaultProps = {
};

ThreadListSubHeader.propTypes = {
};

export { ThreadListSubHeader };
